import React from 'react';
import { s as styled } from './styled-112a8bd0.js';
import { S as SvgIcon } from './SvgIcon-1ee3e5bb.js';

const Wrapper = styled.div `
  display: flex;
`;
const Text = styled.span(({ color, size }) => `
    font-size: ${size === 'sm' ? '0.75rem' : '1rem'};
    color: ${color};
    flex: 1;
  `);
const StyledSvgIcon = styled(SvgIcon)(({ color, iconSize }) => `
    width: ${iconSize === 'sm' ? '1rem' : '1.25rem'};
    height: ${iconSize === 'sm' ? '1rem' : '1.25rem'};
    background-color: ${color};
    margin-right: 0.4rem;
    position: relative;
    top: 1px;
  `);
const Alerts = ({ icon, text, color, size = 'sm', className, }) => {
    return (React.createElement(Wrapper, { className: className },
        icon && React.createElement(StyledSvgIcon, { color: color, name: icon, iconSize: size }),
        React.createElement(Text, { color: color, size: size }, text)));
};

export { Alerts as A };
